import types from '../types/start'
// import timeslotTypes from '../types/timeslot'
// import addressTypes from '../types/address'
// import paymentTypes from '../types/payment'
import {Map, Set} from 'immutable'

const initialRoot = Map({
  loading: Set(),
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.CREATE_RENT:
      return state
        .merge(asyncStart(state, 'createRent'))
    case types.CREATE_RENT_SUCCESS:
      return state
        .merge(asyncSuccess(state, 'createRent'))
    case types.CREATE_RENT_FAIL:
      return state
        .merge(asyncFail(state, 'createRent', action.payload.error))
    case types.ASSIGN_ITEM:
      return state
        .merge(asyncStart(state, 'assignItem'))
    case types.ASSIGN_ITEM_SUCCESS:
      return state
        .merge(asyncSuccess(state, 'assignItem'))
    case types.ASSIGN_ITEM_FAIL:
      return state
        .merge(asyncFail(state, 'assignItem', action.payload.error))
    // case timeslotTypes.MODIFY_TRANSACTION_SUCCESS:
    //   const reserve = state.getIn(['transaction', 'Reserve'])
    //   reserve.Date = action.payload.date.toISOString()
    //   reserve.TimeSlot = action.payload.timeslot
    //   return state.setIn(['transaction', 'Reserve'], reserve)
    // case addressTypes.MODIFY_TRANSACTION_SUCCESS:
    //   return state.set('transaction', state.get('transaction').set('ClientAddress', action.payload.address))
    // case paymentTypes.MODIFY_TRANSACTION_SUCCESS:
    //   return state.set('transaction', state.get('transaction').set('Card', action.payload.card))
    default:
      return state
  }
}

function asyncStart(state, key) {
  return {
    loading: state.get('loading').add(key),
    error: '',
  }
}

function asyncSuccess(state, key) {
  return {
    loading: state.get('loading').remove(key),
    error: '',
  }
}

function asyncFail(state, key, error) {
  return {
    loading: state.get('loading').remove(key),
    error,
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/rent/reducers/start.js